@if (errand?.dialogId) {
  <app-chat
    [dialogId]="errand.dialogId"
    [dialogEndpoint]="dialogEndpoint"
    [visibleForTenantCheckbox]="visibleForTenantCheckbox"
    [isTenantInvolved]="isTenantInvolved"
    (dialogChange)="dialogChange.emit($event)"
  ></app-chat>
} @else if (repairFailed) {
  <app-information-block [text]="'ERRAND_DIALOG.REPAIR_FAILED'"></app-information-block>
  <astral-button
    type="button"
    variant="secondary"
    labelKey="ERRAND_DIALOG.RETRY"
    (click)="retry()"
  ></astral-button>
} @else if (repairing) {
  <app-information-block [text]="'ERRAND_DIALOG.REPAIRING'"></app-information-block>
}
